export const COLORS = {
    GREEN: 'bg-green-500',
    YELLOW: 'bg-yellow-500',
    AMBER: 'bg-amber-500',
    RED: 'bg-red-500',
};
